export default __webpack_public_path__ + "static/RakiuraTrack-credit-HaraldSelke-4767c78ed46cf688aebf6838af4f0a35.jpg";